import { render, staticRenderFns } from "./certificateAuthenticity.vue?vue&type=template&id=0d4937d6&scoped=true"
import script from "./certificateAuthenticity.vue?vue&type=script&lang=js"
export * from "./certificateAuthenticity.vue?vue&type=script&lang=js"
import style0 from "./certificateAuthenticity.vue?vue&type=style&index=0&id=0d4937d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4937d6",
  null
  
)

export default component.exports